define.alias("ember-math-helpers/helpers/lcm", "settings/helpers/lcm");